<script>
  import Select from 'svelte-select';
  import ProfileImg from '../components/ProfileImage.svelte';
  import { onDestroy, onMount } from 'svelte';
  import { client } from 'root/api/index.js';
  import Loader from '../components/Loader.svelte';
  import { masterData, getMasterData } from '../stores/masterData.js';
  import { searchKeyByValue, setYupMessage, configItem } from 'components/Helper.js';
  import { getUserInfo, resetUserData } from '../stores/auth';
  import FormInput from '../components/FormControls/FormInput.svelte';
  import SimpleFileUploader from '../components/SimpleFileUploader.svelte';
  import { createForm } from 'svelte-forms-lib';
  import * as yup from 'yup';
  import { getContext } from 'svelte';
  const showDialog = getContext('showDialog');
  let photoUrl =
    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ8FuEJbKwDdaz1h387130xmYkAIQbZpahhbQ&usqp=CAU';
  let timeZones = [];
  let dateFormates = [];
  let edit = true;
  let responseData;
  let selectedDateFormatId = null;
  let selectedTimeZoneId = null;
  let isFormPending = false;
  let serverErrors = [];
  var mobileObj = { mobile: '' };
  var fileObj = {
    fileId: 0,
    fileName: '',
    filePath: '',
    origionalName: '',
  };
  let defaultValue = {
    firstName: '',
    lastName: '',
    email: '',
    roleId: '',
    password: '',
    confirmPassword: '',
    units: [],
    file: fileObj,
    users: [],
    dateFormatId: undefined,
    timeZoneId: undefined,
    notificationTypes: [],
    mobileNos: [mobileObj],
  };
  setYupMessage(yup);
  const { form, errors, handleChange, handleSubmit } = createForm({
    initialValues: { ...defaultValue },
    validationSchema: yup.object().shape({
      firstName: yup.string().required(),
      lastName: yup.string().required(),
      email: yup.string().email().required('Valid email is required'),
      roleId: yup.string(),
      password: yup
        .string()
        .test('passwordValidate', configItem.passwordValidation.message, function (value) {
          if (value.length == 0) {
            return true;
          }
          if (value != undefined && value != '') {
            const matchVal = value.match(configItem.passwordValidation.expression);
            return matchVal == null ? false : true;
          }
        }),
      confirmPassword: yup.string().when('password', {
        is: (value) => {
          return value.trim().length != 0;
        },
        then: yup
          .string()
          .oneOf([yup.ref('password'), null], 'Passwords must match')
          .required(),
      }),
      units: yup.array().of(
        yup.object().shape({
          unitId: yup.string(),
          name: yup.string(),
          isAssign: yup.boolean(),
        }),
      ),
      file: yup.object().shape({
        fileId: yup.string(),
        fileName: yup.string(),
        filePath: yup.string(),
        origionalName: yup.string(),
      }),
      users: yup.array().of(
        yup.object().shape({
          id: yup.string(),
          userId: yup.number(),
          firstName: yup.string(),
          lastName: yup.string(),
          deleted: yup.number(),
        }),
      ),
      dateFormatId: yup.number().required(),
      timeZoneId: yup.number().required(),
      notificationTypes: yup.array().of(
        yup.object().shape({
          id: yup.string(),
          name: yup.string(),
          email: yup.number(),
          slack: yup.number(),
        }),
      ),
      mobileNos: yup.array().of(
        yup.object().shape({
          id: yup.string(),
          mobile: yup.string(),
        }),
      ),
    }),
    onSubmit: (values) => {
      isFormPending = true;
      client
        .saveProfile(values)
        .then((response) => {
          isFormPending = false;
          edit = true;
          responseData = deepLinking({
            ...values,
            password: '',
            confirmPassword: '',
            file: fileObj,
          });
          resetUserData();
        })
        .catch((err) => {
          isFormPending = false;
          serverErrors = [err.message];
          showDialog({ message: serverErrors });
        });
    },
  });
  function editProfile() {
    edit = !edit;
  }
  const setDropDown = () => {
    if ($form.timeZoneId > 0 && timeZones.length > 0) {
      selectedTimeZoneId = {
        id: $form.timeZoneId,
        name: timeZones[searchKeyByValue(timeZones, 'id', $form.timeZoneId)].name,
      };
    }

    if ($form.dateFormatId > 0 && dateFormates.length > 0) {
      selectedDateFormatId = {
        id: $form.dateFormatId,
        name: dateFormates[searchKeyByValue(dateFormates, 'id', $form.dateFormatId)].name,
      };
    }
  };
  const userRoleId = getUserInfo().roleId;
  let isManager = false;

  onMount(() => {
    getDetail();
  });
  const addMobile = () => {
    let mobileNos = $form.mobileNos;
    mobileNos.push({ ...mobileObj });
    $form.mobileNos = mobileNos;
  };
  const removeMobile = (i) => {
    let mobileNos = $form.mobileNos;
    mobileNos.splice(i, 1);
    $form.mobileNos = mobileNos;
  };
  let oldPhotoUrl;
  let isAjaxLoading = true;
  let isFormUpdateChecking = false;
  let oldFormData = {};
  const getDetail = () => {
    $form = { ...defaultValue };
    selectedDateFormatId = null;
    selectedTimeZoneId = null;
    serverErrors = [];
    client
      .getProfile()
      .then((response) => {
        if (response.data.mobileNos.length <= 0) {
          response.data.mobileNos.push({ ...mobileObj });
        }
        oldPhotoUrl = response.data.photoUrlPath;
        response.data.file = fileObj;
        response.data.password = '';
        response.data.confirmPassword = '';
        responseData = deepLinking(response.data);
        $form = deepLinking(response.data);
        oldFormData = deepLinking(response.data);
        setDropDown();
        isAjaxLoading = false;
        setTimeout(() => {
          isFormUpdateChecking = true;
        }, 1000);
      })
      .catch((err) => {
        showDialog({ message: err.message });
      });
  };
  const deepLinking = (data) => {
    return JSON.parse(JSON.stringify(data));
  };
  const unsubscribe = masterData.subscribe((state) => {
    client.checkAuth().then(() => {
      if (state != undefined) {
        timeZones = getMasterData().timeZones;
        dateFormates = getMasterData().dateFormates;
        let userRoles = getMasterData().userRoleId;
        isManager = userRoles.manager == userRoleId;
        setDropDown();
      }
    });
  });
  onDestroy(() => {
    unsubscribe();
  });
  let editPhoto = false;

  let formUpdate = false;
  const checkUpdate = () => {
    if (isFormUpdateChecking) {
      formUpdate = JSON.stringify(oldFormData) != JSON.stringify($form);
    }
  };
  $: $form && checkUpdate();
</script>

<div class="d-flex h-100 w-100 p-3 flex-column">
  <div class="block-header mb-2">
    <div class="row align-items-center">
      <div class="col"><h2 class="page-title">My Profile</h2></div>
    </div>
  </div>
  <div class="page-content card-content bg-white">
    <div class="d-flex flex-column h-100">
      <div class="page-content p-3">
        <div class="d-flex flex-row justify-content-center h-100">
          <div class="w-100 h-100">
            <div class="d-flex flex-row">
              <div class="profile-user-img">
                {#if isAjaxLoading == false}
                  {#if editPhoto}
                    <div>
                      <SimpleFileUploader
                        on:fileChanged={(event) => {
                          if (event.detail.type == 'add' || event.detail.type == 'delete') {
                            $form.photoUrl =
                              event.detail.type == 'add' ? event.detail.fileName : '';
                            // client
                            // .userUpdateProfilePhoto({
                            //   photoUrl:event.detail.type=="add"?event.detail.fileName:""
                            // })
                            // .then((response) => {
                            //   // editPhoto=isFormPending=false;
                            //   // isAjaxLoading=true
                            //   resetUserData();
                            //   // setTimeout(()=>{
                            //   //   getDetail();
                            //   // },100)
                            // })
                          } else if (event.detail.type == 'uploading') {
                            isFormPending = true;
                          } else if (event.detail.type == 'uploaded') {
                            isFormPending = false;
                          }
                        }}
                        photoUrl={oldPhotoUrl}
                        requestFrom="user-profile"
                        entityId={$form.id}
                      />
                    </div>
                  {:else}
                    <div class="profile-image position-relative">
                      <div
                        class="profile-edit position-absolute d-flex align-items-center justify-content-center"
                      >
                        <button
                          style="border: 0;border-radius: 15px;"
                          class="btn-link"
                          on:click={() => {
                            editPhoto = true;
                          }}
                        >
                          <img
                            alt=""
                            class="icon-16"
                            src="/images/pencil-gray.svg"
                          />
                        </button>
                      </div>
                      <ProfileImg
                        size={120}
                        firstName={$form.firstName}
                        lastName={$form.lastName}
                        photoUrl={oldPhotoUrl}
                        className="d-inline-block align-middle"
                      />
                    </div>
                  {/if}
                {/if}
              </div>
              <div class="w-100">
                <div class="row">
                  <div class="col-md-4">
                    <div class="user-details-left position-relative right-divider">
                      {#if edit}
                        <h3 class="text-muted mb-1">
                          {$form.firstName}
                          {$form.lastName}
                        </h3>
                      {:else}
                        <div class="row">
                          <div class="col-md-6">
                            <FormInput
                              labelColor="color-blue"
                              inputStyle={edit
                                ? 'form-control form-inactive'
                                : 'form-control text-muted'}
                              label="First Name"
                              placeholder="Enter First Name"
                              handleChange={handleChange}
                              disabled={edit}
                              name="firstName"
                              error={$errors.firstName}
                              bind:value={$form.firstName}
                            />
                          </div>
                          <div class="col-md-6">
                            <FormInput
                              labelColor="color-blue"
                              inputStyle={edit
                                ? 'form-control form-inactive'
                                : 'form-control text-muted'}
                              label="Last Name"
                              placeholder="Enter Last Name"
                              handleChange={handleChange}
                              disabled={edit}
                              name="lastName"
                              error={$errors.lastName}
                              bind:value={$form.lastName}
                            />
                          </div>
                        </div>
                      {/if}

                      <span class="color-blue font-weight-400 font-size-12 mb-2 d-block">
                        {$form.roleName}
                      </span>
                      {#if $form.slackUsername}
                        <span
                          class=" font-weight-400 font-size-12 mb-2 ms-0"
                          style="margin-left:10px;"
                        >
                          Slack User Name: {$form.slackUsername}
                        </span>
                      {/if}
                      <div class="mt-2">
                        <span class="color-blue font-weight-400 font-size-12 mb-2"
                          >Business Units</span
                        >
                        <div class="d-flex flex-row mt-1 flex-wrap">
                          {#each $form.units as item, i}
                            <span
                              class="comp-bage px-1 py-1 rounded text-muted me-1 text-nowrap mb-1"
                              >{item.name}</span
                            >
                          {/each}
                        </div>
                      </div>

                      <div class="mt-3">
                        {#if isManager && $form.users.length > 0}
                          <span class="color-blue font-weight-400 font-size-12 mb-3"
                            >Team Members</span
                          >
                          <div class="mt-1">
                            <div class="d-flex flex-row mt-1 flex-wrap">
                              {#each $form.users.filter((item, itemKey) => {
                                return searchKeyByValue($form.users, 'userId', item.userId) == itemKey;
                              }) as item, i}
                                <span class="comp-bage px-1 py-1 mb-1 rounded text-muted me-1"
                                  >{$form.users[i].firstName}
                                  {$form.users[i].lastName}</span
                                >
                              {/each}
                            </div>
                          </div>
                        {/if}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="right-divider position-relative">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group mb-3">
                            <FormInput
                              labelColor="color-blue"
                              inputStyle={edit
                                ? 'form-control form-inactive'
                                : 'form-control text-muted'}
                              label="Email Address"
                              placeholder="Enter Email"
                              handleChange={handleChange}
                              disabled={edit}
                              name="email"
                              error={$errors.email}
                              bind:value={$form.email}
                            />
                          </div>
                        </div>

                        {#each $form.mobileNos as item, i}
                          <div class="col-md-6">
                            <div class="d-flex flex-row align-items-center">
                              <div class="w-100">
                                <FormInput
                                  labelColor="color-blue"
                                  inputStyle={edit
                                    ? 'form-control form-inactive'
                                    : 'form-control text-muted'}
                                  label="Phone Number"
                                  placeholder="Enter Mobile"
                                  handleChange={handleChange}
                                  disabled={edit}
                                  name={`mobileNos[${i}].mobile`}
                                  error={$errors.mobileNos[i] != undefined &&
                                  $errors.mobileNos[i].mobile != undefined
                                    ? $errors.mobileNos[i].mobile
                                    : ''}
                                  bind:value={$form.mobileNos[i].mobile}
                                />
                              </div>
                              <div class="add-btn-block">
                                {#if !edit}
                                  <button
                                    class="bg-transparent border-0 ms-2"
                                    on:click={() => {
                                      if (i == 0) {
                                        addMobile();
                                      } else {
                                        removeMobile(i);
                                      }
                                    }}
                                  >
                                    <img
                                      class="icon-16"
                                      alt=""
                                      src={i == 0 ? '/images/plus.svg' : '/images/cancel.svg'}
                                    />
                                  </button>
                                {/if}
                              </div>
                            </div>
                          </div>
                        {/each}
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group mb-3 select-block">
                            <span class="color-blue font-weight-400 font-size-12 mb-0"
                              >Time Zone</span
                            >
                            <div class={edit ? 'mt-1 form-inactive' : 'mt-1'}>
                              <Select
                                class="form-control"
                                bind:selectedValue={selectedTimeZoneId}
                                items={timeZones}
                                showChevron={true}
                                isClearable={true}
                                isDisabled={edit}
                                placeholder="Select: Time Zone"
                                on:select={(ev) => {
                                  $form.timeZoneId = ev.detail.id;
                                }}
                                on:clear={(ev) => {}}
                                optionIdentifier="id"
                                getSelectionLabel={(option) => {
                                  return option.name;
                                }}
                                getOptionLabel={(option) => {
                                  return option.name;
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group mb-0 select-block">
                            <span class="color-blue font-weight-400 font-size-12 mb-3"
                              >Date Format</span
                            >
                            <div class={edit ? 'mt-1 form-inactive' : 'mt-1'}>
                              <Select
                                class="form-control"
                                bind:selectedValue={selectedDateFormatId}
                                items={dateFormates}
                                showChevron={true}
                                isClearable={true}
                                isDisabled={edit}
                                placeholder="Select: Date Format"
                                on:select={(ev) => {
                                  $form.dateFormatId = ev.detail.id;
                                }}
                                on:clear={(ev) => {}}
                                optionIdentifier="id"
                                getSelectionLabel={(option) => {
                                  return option.name;
                                }}
                                getOptionLabel={(option) => {
                                  return option.name;
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group mb-3 position-relative">
                          <FormInput
                            labelColor="color-blue"
                            inputStyle={edit
                              ? 'form-control form-inactive'
                              : 'form-control text-muted'}
                            label="Update Password"
                            placeholder={edit ? '••••••' : 'Enter Password'}
                            handleChange={handleChange}
                            disabled={edit}
                            type="password"
                            name="password"
                            error={$errors.password}
                            bind:value={$form.password}
                          />
                          {#if !edit}
                            <label
                              for=""
                              class="password-text">Alphanumeric with one special character</label
                            >
                          {/if}
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group mb-3 position-relative">
                          <FormInput
                            labelColor="color-blue"
                            inputStyle={edit
                              ? 'form-control form-inactive'
                              : 'form-control text-muted'}
                            label="Confirm Password"
                            placeholder={edit ? '••••••' : 'Enter Confirm Password'}
                            handleChange={handleChange}
                            disabled={edit}
                            type="password"
                            name="confirmPassword"
                            error={$errors.confirmPassword}
                            bind:value={$form.confirmPassword}
                          />
                          {#if !edit}
                            <label
                              for=""
                              class="password-text">Alphanumeric with one special character</label
                            >
                          {/if}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="profile-edit-btn">
                {#if edit}
                  <button
                    on:click={editProfile}
                    class="btn btn-link p-0 shadow-none text-muted bg-transparent border-0 font-size-12"
                    ><img
                      alt=""
                      class="me-1 icon-12"
                      src="/images/pencil-gray.svg"
                    />Edit</button
                  >
                {/if}
              </div>
            </div>
            <hr class="hrline my-4" />
            <div class="row">
              <div class="col-md-12 mb-4">
                <h3 class="font-size-18">Notification Settings</h3>
              </div>

              <div class="col-md-6">
                <div class="options-block">
                  <div class="d-flex flex-row">
                    <div class="notifications-title w-100">
                      <h3 class="font-size-16 font-weight-400 text-muted">Notifications</h3>
                    </div>
                    <div
                      class="slack-notification d-flex text-center align-items-center justify-content-center"
                    >
                      <span class="text-muted">Email</span>
                    </div>
                    <!-- <div
					  class="slack-notification  d-flex  text-center align-items-center justify-content-center"
					>
					  <span class="text-muted">Slack</span>
					</div> -->
                  </div>

                  {#each $form.notificationTypes as item, i}
                    {#if i % 2 == 0}
                      <div class="d-flex flex-row profile-options py-2 align-items-center">
                        <div class="notifications-title w-100">
                          <span class="text-muted">{item.name}</span>
                        </div>
                        <div
                          class="slack-notification d-flex text-center align-items-center justify-content-center"
                        >
                          <div class="form-check form-switch profile-switch">
                            <input
                              class="form-check-input shadow-none"
                              type="checkbox"
                              id="flexSwitchCheckDefault"
                              checked={item.email}
                              on:change={(event) => {
                                if (item.slack == 0 && event.target.checked == false) {
                                  item.slack = 1;
                                }
                                item.email = event.target.checked ? 1 : 0;
                              }}
                            />
                          </div>
                        </div>
                        <!-- <div
						  class="slack-notification  d-flex  text-center align-items-center justify-content-center"
						>
						  <div class="form-check form-switch profile-switch">
							<input
							  class="form-check-input shadow-none"
							  type="checkbox"
							  id="flexSwitchCheckDefault"
							  checked={item.slack}
							  on:change={(event) => {
								if(item.email==0 && event.target.checked==false){
								  item.email=1
								}
								item.slack = event.target.checked ? 1 : 0;
							  }}
							/>
						  </div>
						</div> -->
                      </div>
                    {/if}
                  {/each}
                </div>
              </div>

              <div class="col-md-6">
                <div class="options-block">
                  <div class="d-flex flex-row">
                    <div class="notifications-title w-100">
                      <h3 class="font-size-16 font-weight-400 text-muted">Notifications</h3>
                    </div>
                    <div
                      class="slack-notification d-flex text-center align-items-center justify-content-center"
                    >
                      <span class="text-muted">Email</span>
                    </div>
                    <!-- <div
					  class="slack-notification  d-flex  text-center align-items-center justify-content-center"
					>
					  <span class="text-muted">Slack</span>
					</div> -->
                  </div>

                  {#each $form.notificationTypes as item, i}
                    {#if i % 2 != 0}
                      <div class="d-flex flex-row profile-options py-2 align-items-center">
                        <div class="notifications-title w-100">
                          <span class="text-muted">{item.name}</span>
                        </div>
                        <div
                          class="slack-notification d-flex text-center align-items-center justify-content-center"
                        >
                          <div class="form-check form-switch profile-switch">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              id="flexSwitchCheckDefault"
                              checked={item.email}
                              on:change={(event) => {
                                if (item.slack == 0 && event.target.checked == false) {
                                  item.slack = 1;
                                }
                                item.email = event.target.checked ? 1 : 0;
                              }}
                            />
                          </div>
                        </div>
                        <!-- <div
						  class="slack-notification  d-flex  text-center align-items-center justify-content-center"
						>
						  <div class="form-check form-switch profile-switch">
							<input
							  class="form-check-input"
							  type="checkbox"
							  id="flexSwitchCheckDefault"
							  checked={item.slack}
							  on:change={(event) => {
								if(item.email==0 && event.target.checked==false){
								  item.email=1
								}
								item.slack = event.target.checked ? 1 : 0;
							  }}
							/>
						  </div>
						</div> -->
                      </div>
                    {/if}
                  {/each}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class=" d-flex align-items-center justify-content-end p-3">
        <button
          class="trans-btn btn mb-0 px-3 font-size-12 outline-0 btn-cancel me-2"
          on:click={() => {
            edit = true;
            $form = deepLinking(responseData);
          }}>Cancel</button
        >
        <button
          class="btn background-blue mb-0 text-white px-4 add-task font-size-12 btn-primary"
          on:click={handleSubmit}
          >{#if isFormPending}
            <Loader />
          {:else}Save{/if}</button
        >
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  .profile-image {
    width: 128px;
    height: 128px;
    border-radius: 128px;
    border: 4px solid $blue-color;
  }

  .user-details-left {
    h3 {
      font-size: 18px;
    }
    .comp-bage {
      background: rgba($input-border-color, 0.6);
    }
  }
  .hrline {
    background: $input-border-color;
  }
  .profile-switch {
    input {
      height: 27px;
      width: 52px;
      shadow: none;
    }
    .form-check-input {
      border: 1px solid $input-border-color;
      &:focus {
        shadow: none;
      }
    }
  }
  .profile-options {
    border-bottom: 1px solid $input-border-color;
  }
  .options-block {
    max-width: 500px;
  }
  .slack-notification {
    flex: 0 0 100px;
    width: 100px;
  }

  .profile-edit {
    right: 0;
    bottom: 0px;
    background: #fff;
    box-shadow: 5px 6px 10px 0 rgba(82, 63, 105, 0.05);
    width: 30px;
    z-index: 1;
    height: 30px;
    border-radius: 30px;
  }
  .profile-user-img {
    flex: 0 0 140px;
    max-width: 140px;
    margin-right: 20px;
  }
  .profile-edit-btn {
    flex: 0 0 76px;
    max-width: 76px;
    justify-content: flex-end;
    display: flex;
    align-items: flex-start;
  }
  .add-btn-block {
    margin-top: 10px;
  }
  .password-text {
    color: $lead-color;
    position: absolute;
    right: 0px;
    bottom: -18px;
    font-size: 11px;
    white-space: nowrap;
  }
</style>
